import loglevel, { LogLevelDesc } from 'loglevel';
import pino from 'pino';

import { getPublicEnvironmentConfig } from '@/env/client/config';

const env = getPublicEnvironmentConfig();

function getLogLevel() {
  // Environment should take precedence
  const envLogLevel = env.NEXT_PUBLIC_LOG_LEVEL;
  if (envLogLevel) return envLogLevel;

  switch (process.env.NEXT_PUBLIC_ENVIRONMENT) {
    case 'local':
    case 'dev':
      return 'debug';
    case 'live':
    default:
      return 'info';
  }
}

export const defaultLogger = pino({
  level: getLogLevel(),
  formatters: {
    level(level) {
      return { level };
    },
  },
  base: { env: env.NEXT_PUBLIC_ENVIRONMENT, subsystem: 'em-booking-ui-v1' },
});

export const getLogger = () => {
  return defaultLogger;
};

((global as any).window || {})._logging = {
  enableTrace() {
    loglevel.enableAll();
  },
  resetLogLevel() {
    loglevel.setLevel('warn');
  },
  setLevel(level: LogLevelDesc) {
    loglevel.setLevel(level);
  },
};
